'use client'

import { css } from '@lastbrand/web-ui-styled-system/css'

import { Image as ImageC } from '@src/quince-components/src'

import type { ProductDetailsIconDSProps } from './types'

const iconClass = css({
  borderRadius: '4px',
  backgroundColor: 'paperwhite',
  display: 'flex',
  padding: 'space-8',
  flexDirection: 'row',
  alignItems: 'center',
  gap: 'space-8',
  flexShrink: 0,
})

const iconImageWrapperClass = css({
  width: { base: '24px!', lg: '30px!' },
  height: { base: '24px!', lg: '30px!' },
})

const iconTextClass = css({
  textStyle: 'body-12-strong',
  textTransform: 'none',
})

export const ProductDetailsIconDS = ({ displayTitle, image }: ProductDetailsIconDSProps) => (
  <div className={iconClass}>
    {image && <ImageC {...image} className={iconImageWrapperClass} />}
    <div className={iconTextClass}>{displayTitle}</div>
  </div>
)
